import React, { useMemo, useState } from 'react';
import LanguageToggle from './LanguageToggle';

export default function ImprintPage() {
  const [language, setLanguage] = useState('de');

  const content = useMemo(
    () => ({
      de: (
        <div className="space-y-4">
          <h1 className="text-3xl font-semibold">Impressum</h1>
          <p>Angaben gemäß § 5 DDG</p>
          <address className="not-italic leading-relaxed">
            NumSolve.org
            <br />
            Denis Khimin
            <br />
            Schneiderberg 19
            <br />
            30167 Hannover
          </address>
          <p>
            <strong>Kontakt:</strong>
            <br />
            E-Mail: <a className="text-fuchsia-600 hover:underline" href="mailto:info@numsolve.org">info@numsolve.org</a>
          </p>
          <p>
            <strong>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:</strong>
            <br />
            Denis Khimin, c/o MDC Management #2966, Welserstraße 3, 87463 Dietmannsried
          </p>
          <section className="space-y-2">
            <h2 className="text-2xl font-semibold">Haftung für Inhalte</h2>
            <p>
              Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen
              Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte
              oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
              Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
              Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer
              konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte
              umgehend entfernen.
            </p>
          </section>
          <section className="space-y-2">
            <h2 className="text-2xl font-semibold">Haftung für Links</h2>
            <p>
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können
              wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
              Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche
              Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
              inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>
          <section className="space-y-2">
            <h2 className="text-2xl font-semibold">Urheberrecht</h2>
            <p>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser Seite unterliegen dem deutschen Urheberrecht.
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
              bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
              nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber
              erstellt wurden, werden die Urheberrechte Dritter beachtet und entsprechende Inhalte als solche gekennzeichnet.
              Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis.
              Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
          <p className="mt-4 text-xs text-slate-500">
            <a
              href="https://geschaefts-adresse-mieten.de/"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="hover:underline"
            >
              Service von geschaefts-adresse-mieten
            </a>
          </p>
        </div>
      ),
      en: (
        <div className="space-y-4">
          <h1 className="text-3xl font-semibold">Imprint</h1>
          <p>Information pursuant to § 5 German Digital Services Act (DDG)</p>
          <address className="not-italic leading-relaxed">
            NumSolve.org
            <br />
            Denis Khimin
            <br />
            c/o MDC Management #2966
            <br />
            Welserstraße 3
            <br />
            87463 Dietmannsried
            <br />
            Germany
          </address>
          <p>
            <strong>Contact:</strong>
            <br />
            Email: <a className="text-fuchsia-600 hover:underline" href="mailto:info@numsolve.org">info@numsolve.org</a>
          </p>
          <p>
            <strong>Responsible for editorial content pursuant to § 18 (2) MStV:</strong>
            <br />
            Denis Khimin, c/o MDC Management #2966, Welserstraße 3, 87463 Dietmannsried, Germany
          </p>
          <section className="space-y-2">
            <h2 className="text-2xl font-semibold">Liability for Content</h2>
            <p>
              As a service provider, we are responsible for our own content on these pages in accordance with § 7 (1) DDG and the
              general laws. However, according to §§ 8 to 10 DDG, we are not obliged to monitor transmitted or stored third-party
              information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of
              information under the general laws remain unaffected. Liability in this respect is only possible from the time we
              become aware of a specific infringement. If we become aware of any legal violations, we will remove the content in
              question immediately.
            </p>
          </section>
          <section className="space-y-2">
            <h2 className="text-2xl font-semibold">Liability for Links</h2>
            <p>
              Our website contains links to external third-party websites whose content we cannot control. Therefore, we cannot accept
              any liability for this external content. The respective provider or operator of the linked pages is always responsible for
              their content. The linked pages were checked for possible legal violations at the time the links were created. Unlawful
              content was not apparent at that time. Permanent monitoring of the linked pages is, however, not reasonable without
              concrete evidence of an infringement. As soon as we become aware of legal violations, we will remove such links
              immediately.
            </p>
          </section>
          <section className="space-y-2">
            <h2 className="text-2xl font-semibold">Copyright</h2>
            <p>
              The content and works created by the site operators on these pages are subject to German copyright law. The reproduction,
              processing, distribution, and any kind of use outside the limits of copyright require the prior written consent of the
              respective author or creator. Downloads and copies of this site are permitted for private, non-commercial use only.
              Where the content on this site was not created by the operator, the copyrights of third parties are respected and such
              content is marked accordingly. Should you nevertheless notice a copyright infringement, please inform us. Upon becoming
              aware of legal infringements, we will remove the relevant content immediately.
            </p>
          </section>
          <p className="mt-4 text-xs text-slate-500">
            <a
              href="https://geschaefts-adresse-mieten.de/"
              rel="nofollow noopener noreferrer"
              target="_blank"
              className="hover:underline"
            >
              Service provided by geschaefts-adresse-mieten
            </a>
          </p>
        </div>
      ),
    }),
    []
  );

  return (
    <section className="relative mx-auto w-full max-w-4xl px-6 pb-24 pt-28 text-white lg:px-16">
      <div className="pointer-events-none absolute inset-x-0 top-10 -z-10 h-64 rounded-full bg-gradient-to-r from-[#8b5cf6]/25 via-transparent to-[#ec4899]/25 blur-3xl" />
      <header className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-3">
          <p className="text-sm uppercase tracking-[0.35em] text-white/60">Legal disclosure</p>
          <h1 className="text-4xl font-semibold leading-tight md:text-5xl">Imprint</h1>
          <p className="max-w-2xl text-lg text-white/70">
            Mandatory contact and responsibility details for NumSolve.
          </p>
        </div>
        <LanguageToggle value={language} onToggle={() => setLanguage(language === 'de' ? 'en' : 'de')} />
      </header>
      <div className="rounded-3xl border border-white/10 bg-white/90 p-8 text-slate-900 shadow-[0_35px_65px_-45px_rgba(76,29,149,0.8)] backdrop-blur">
        {content[language]}
      </div>
    </section>
  );
}
